import React from 'react';
import cx from 'classnames';
import { RegionReportItemsLabel } from './RegionReportItemsLabel';
import styles from '../RegionReport.css';
import { LabelColor, YieldRegionReport } from '../../../../types';

export type ColorStatsLabelProps = {
  allowHover?: boolean;
  colors: LabelColor;
  dataTestId: string;
  item: YieldRegionReport;
  onClick: (item: YieldRegionReport) => void;
  showIcon: boolean;
  index: number;
  cropCode: string;
  cropNominalWeight?: number;
};

function getCircleColor(item: YieldRegionReport, colorsList: LabelColor = []) {
  const matches = colorsList.filter((color) => color.label === item.label);
  return matches.length > 0 ? matches[0].color : '';
}

export const ColorStatsLabel = ({
  allowHover = true,
  colors,
  dataTestId,
  index,
  item,
  onClick,
  showIcon,
  cropCode,
  cropNominalWeight
}: ColorStatsLabelProps) => {
  const { averageYield, area } = item;

  return (
    <div
      className={cx(styles.content, { [styles.contentRow]: allowHover })}
      data-test-id={`dmb-region-report-${dataTestId}-yield-stats-label`}
      key={`dmb-region-report-item-${item.label}`}
      onClick={() => onClick(item)}
    >
      <div className={styles.first}>
        <div
          className={styles.hybridCircle}
          style={{ backgroundColor: getCircleColor(item, colors) }}
          data-test-id="hybrid-circle"
        />
        <div data-test-id={`dmb-region-report-${dataTestId}-label`}>
          {item.label}
        </div>
      </div>
      <RegionReportItemsLabel 
        area={area} 
        averageYield={averageYield} 
        dataTestId={dataTestId} 
        showIcon={showIcon} 
        index={index}
        cropCode={cropCode}
        cropNominalWeight={cropNominalWeight}
      />
    </div>
  );
};